import { Box } from '@material-ui/core';
import { IAlgoliaItem } from 'graph_ql/item/types';
import { AlgoliaInput, AlgoliaResponse } from 'graph_ql/types/types';
import { RootState } from 'redux/store';
import styles from '../index.module.scss';
import config from 'config';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { SEARCH_ITEM_CREATED } from 'graph_ql/search/search_item_created';
import { useHistory } from 'react-router-dom';
import { PATH } from 'routes/constant';
import ArrowRight from 'assets/img/homepage-stylist/arrow-right-icon.png';
import { GET_MY_STYLES } from 'graph_ql/styles/queries';

export const StudioSection = () => {
    const userData = useSelector((state: RootState) => state.userDetail.me);
    const history = useHistory();
    const myItemsVariables = useMemo(() => {
        let filters = `creator:"${userData?.id}" AND status: available`;

        return {
            index: config.algolia.algolia_prefix + 'item_created',
            filters,
            hit: config.algoliaHitPerPage,
            page: 0,
        };
    }, [userData.id]);

    const { data: myItemsData } = useQuery<AlgoliaResponse<IAlgoliaItem, 'items'>, AlgoliaInput>(SEARCH_ITEM_CREATED, {
        variables: myItemsVariables,
        fetchPolicy: 'network-only',
    });

    const myStylesVariables = useMemo(() => {
        const filters = `user.id:${userData?.id}`;
        return {
            index: config.algolia.algolia_prefix + 'styles',
            filters: filters,
            hit: config.algoliaHitPerPage,
            page: 0,
        };
        // eslint-disable-next-line
    }, [userData.id]);

    const { data: myStylesData } = useQuery(GET_MY_STYLES, {
        variables: myStylesVariables,
        fetchPolicy: 'network-only',
    });

    const CreatedItem = ({ item }) => {
        if (item && item!.images?.length > 0) {
            return (
                <Box flex={0.3}>
                    <img alt="section-icon" className={styles.studioItem} src={item.images[0]} />
                </Box>
            );
        }

        return null;
    };

    return (
        <Box className={styles.sectionContainer} maxWidth="100%" overflow={'auto'}>
            <Box className={styles.sectionTitle}>My Atelier</Box>
            <Box display={'flex'} flexDirection={'row'} style={{ gap: 10 }}>
                <Box
                    className={styles.studioContainer}
                    flex={1}
                    onClick={() => {
                        history.push(PATH.MY_ITEMS);
                    }}
                >
                    <Box className={styles.studioTitle}>
                        Items
                        <span className={styles.studioItemNumber}>
                            ({myItemsData?.items ? myItemsData?.items?.nbHits : 0})
                        </span>
                    </Box>
                    <img src={ArrowRight} alt="section-icon" className={styles.studioArrowRightIcon} />
                    <Box className={styles.studioListItems}>
                        {myItemsData?.items.hits.slice(0, 20).map((item, index) => {
                            return <CreatedItem key={index} item={item} />;
                        })}
                    </Box>
                </Box>
                <Box
                    className={styles.studioContainer}
                    flex={1}
                    onClick={() => {
                        history.push(PATH.MY_STYLES);
                    }}
                >
                    <Box className={styles.studioTitle}>
                        Styles
                        <span className={styles.studioItemNumber}>
                            ({myStylesData?.locationsInRadius ? myStylesData?.locationsInRadius?.nbHits : 0})
                        </span>
                    </Box>
                    <img alt="section-icon" src={ArrowRight} className={styles.studioArrowRightIcon} />
                    <Box className={styles.studioListItems}>
                        {myStylesData?.locationsInRadius.hits.slice(0, 20).map((item, index) => {
                            return <CreatedItem key={index} item={item} />;
                        })}
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};
